// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"121":"f5fe6308398f8668","539":"a223af70b8822c3c"}[chunkId] + ".js";
};